import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ConfirmationModal } from 'seagull';
import { RichTextViewer } from 'seagull/components/RichTextViewer';
import { useOverlayContext } from '~/contexts';
import styles from './QuillViewerModal.module.scss';
export function useShowQuillViewerModal() {
    const { showModal } = useOverlayContext();
    return useCallback((_0)=>{
        let { biName = 'quill_viewer_modal', closeOnEscapeKey, closeOnClickOutside } = _0, props = _object_without_properties(_0, [
            "biName",
            "closeOnEscapeKey",
            "closeOnClickOutside"
        ]);
        return showModal({
            biName,
            openBottomSheetOnMobile: true,
            closeOnEscapeKey,
            closeOnClickOutside,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(QuillViewerModal, _object_spread_props(_object_spread({}, props), {
                    onClose: dismissModal
                }));
            }
        });
    }, [
        showModal
    ]);
}
export const QuillViewerModal = (props)=>{
    const { title, value, onClose, testId } = props;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'quill_viewer_confirm'
            },
            secondaryButton: {
                name: 'quill_viewer_cancel'
            }
        },
        overflowContent: true,
        contentPadding: "small",
        width: "800px",
        height: "calc(100% - 128px)",
        title: title,
        onCloseButtonClick: onClose,
        testId: testId,
        content: /*#__PURE__*/ _jsx("div", {
            className: styles.quillViewerContainer,
            children: /*#__PURE__*/ _jsx(RichTextViewer, {
                value: value,
                size: "p1"
            })
        })
    });
};
